/* FATE Footer: one title reveal and interruptible accordion continuity. */
(() => {
  if (customElements.get('fate-footer-editorial')) return;
  class FateFooterEditorial extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.animations = new Set();
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const signal = this.controller.signal;
      this.reducedMotion.addEventListener('change', () => this.stopAnimations(), { signal });
      this.querySelectorAll('.fate-footer__menu > summary').forEach(summary => {
        summary.addEventListener('click', event => this.toggleMenu(event, summary), { signal });
      });
      if (!this.motionAllowed() || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        if (!this.motionAllowed()) return;
        this.querySelectorAll('.fate-footer__heading-line > span').forEach((line, index) => {
          this.play(line, [
            { clipPath: 'inset(0 0 90% 0)', transform: 'translateY(12%)' },
            { clipPath: 'inset(0 0 0 0)', transform: 'translateY(0)' }
          ], { duration: 480, delay: index * 60, easing: 'cubic-bezier(.16,1,.3,1)' });
        });
      }, { threshold: 0.12 });
      this.observer.observe(this);
    }
    motionAllowed() {
      return this.dataset.motion !== 'off' && !this.reducedMotion.matches && typeof this.animate === 'function';
    }
    play(element, frames, options) {
      const animation = element.animate(frames, options);
      this.animations.add(animation);
      animation.finished.then(() => this.animations.delete(animation), () => this.animations.delete(animation));
      return animation;
    }
    stopAnimations() {
      this.animations.forEach(animation => animation.cancel());
      this.animations.clear();
    }
    toggleMenu(event, summary) {
      // Native keyboard activation and reduced motion remain immediate.
      if (event.detail === 0 || !this.motionAllowed()) {
        this.stopAnimations();
        return;
      }
      event.preventDefault();
      const details = summary.parentElement;
      const rows = [...details.parentElement.children];
      const positions = rows.map(row => row.getBoundingClientRect().top);
      this.stopAnimations();
      details.open = !details.open;
      rows.forEach((row, index) => {
        const distance = positions[index] - row.getBoundingClientRect().top;
        if (Math.abs(distance) < 1) return;
        this.play(row, [{ transform: `translateY(${distance}px)` }, { transform: 'translateY(0)' }], {
          duration: details.open ? 240 : 170, easing: 'cubic-bezier(.16,1,.3,1)'
        });
      });
      if (details.open) {
        this.play(details.querySelector('.fate-footer__menu-content'), [
          { opacity: 0.55, transform: 'translateY(-5px)' }, { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 200, easing: 'cubic-bezier(.16,1,.3,1)' });
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.stopAnimations();
    }
  }
  customElements.define('fate-footer-editorial', FateFooterEditorial);
})();
